import { connect } from 'react-redux';
import ModalCommentForm from './ModalCommentForm';
import { addSingleComment } from '../../../redux/actions';

const mapDispatchToProps = {
  onSubmit: addSingleComment,
};

export default connect(null, mapDispatchToProps)(ModalCommentForm);
